var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-selected-order-list"
  }, [_c('div', {
    staticClass: "order-list-header"
  }, [_c('div', {
    staticClass: "order-list-title"
  }, [_c('p', {
    staticClass: "same-title"
  }, [_vm._v("精选晒单")]), _c('div', {
    staticClass: "all-btn",
    on: {
      "click": _vm.goKankanSelectList
    }
  }, [_c('div', [_vm._v("查看更多")]), _c('ycf-svg', {
    staticClass: "iconfont play_btn",
    attrs: {
      "icon-name": "right-arrow"
    }
  })], 1)])]), _c('div', {
    staticClass: "selected-order-list"
  }, _vm._l(_vm.shareOrderList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "list-item",
      on: {
        "click": _vm.goKankanSelectList
      }
    }, [item.picUrlArr && item.picUrlArr.length ? _c('ycf-image', {
      staticClass: "picture-card",
      attrs: {
        "src": item.picUrlArr[0] + '?imageView2/1/w/220/h/220/interlace/1'
      }
    }) : _c('ycf-image', {
      staticClass: "picture-card",
      attrs: {
        "src": item.videoUrl + '?vframe/jpg/offset/1'
      }
    })], 1);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };